import { FormikProvider, useFormik } from "formik";
import { BILLING_TYPE, PaymentInfo } from "../../../../../../../types/payment.type";
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading";
import { useEffect, useMemo, useState } from "react";
import InputFormik from "../../../../../../../common/components/form/InputFormik";
import InputMoney from "../../../../../../../common/components/form/CurrencyInputFormik";
import ComboBoxFormik from "../../../../../../../common/components/form/ComboBoxFormik";
import { InstallmentOption, useCalculateInstallmentOptions } from "../../../../../helpers/calculationUtils";
import { ConvertDeposit } from "./customHook/useConvertDeposit";

type Props = {
  payments: PaymentInfo[];
  renterId: string;
  onClose: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (values: any) => unknown
}


export default function FormConvertDeposit(props: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { initialValues, installmentDeposit } = ConvertDeposit({ renterId: props.renterId, payments: props.payments });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);
        const result = await props.onSubmit(values);
        return result;
      } finally {
        setIsSubmitting(false);
      }
    }
  })

  const calculateInstallmentOptions = useCalculateInstallmentOptions();
  const installmentOptions: InstallmentOption[] = useMemo(() => {
    return calculateInstallmentOptions(formik.values.newValueDeposit, 3)
  }, [formik.values.newValueDeposit, calculateInstallmentOptions]);

  useEffect(() => {
    const valueSelectedOption = installmentOptions.find(
      option => option.value === formik.values.installmentOption
    );
    const installmentAmount = valueSelectedOption?.valueOption || 0;
    if (installmentAmount && Number(formik.values.valueInstallment) !== Number(installmentAmount)) {
      formik.setFieldValue('valueInstallment', installmentAmount);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.installmentOption, installmentOptions]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <div className="flex flex-col">
          {installmentDeposit.length > 0 ? (
            <section className="flex flex-col">
              <h3 className="text-lg font-semibold">
                Caução facilitado em caução normal
              </h3>
              <div className="grid grid-cols-2 gap-3">
                <InputMoney
                  label="Valor da caução"
                  name="valueDeposit"
                  required={true}
                  readonly={true}
                />
                <InputFormik
                  label="Numero de parcelas geradas"
                  name="installmentDeposit"
                  value={installmentDeposit.length.toString()}
                  required={true}
                  readonly={true}
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <InputMoney
                  label="Novo valor da caução"
                  name="newValueDeposit"
                  required={true}
                />
                <InputFormik
                  label="Data de pagamento"
                  name="paymentDate"
                  type="date"
                  required={true}
                  readonly={true}
                />
                <ComboBoxFormik
                  label="Tipo de pagamento"
                  name="paymentType"
                  options={[
                    { label: '-', value: "" },
                    { label: 'PIX', value: BILLING_TYPE.PIX },
                    { label: 'CREDITO', value: BILLING_TYPE.CREDIT_CARD },
                    { label: 'BOLETO', value: BILLING_TYPE.BOLETO }
                  ]}
                />
                {(formik.values.paymentType === BILLING_TYPE.BOLETO || formik.values.paymentType === BILLING_TYPE.CREDIT_CARD) && (
                  <ComboBoxFormik
                    name="installmentOption"
                    label="Escolha a opção de parcelamento:"
                    options={installmentOptions}
                    required={true}
                  />
                )}

              </div>
            </section>
          ) :
            (
              <section className="flex flex-col gap-3">
                <h3 className="text-lg font-semibold">
                  Caução normal em caução facilitado
                </h3>
                <div className="grid grid-cols-2 gap-3">
                  <InputMoney
                    label="Valor da caução"
                    name="valueDeposit"
                    required={true}
                    readonly={true}
                  />
                  <InputFormik
                    label="Tipo de pagamento"
                    name="paymentType"
                    required={true}
                    readonly={true}
                  />

                </div>
                <div className="grid grid-cols-2 gap-3">
                  <InputMoney
                    label="Novo valor da caução"
                    name="newValueDeposit"
                    value={400}
                    required={true}
                    readonly={true}
                  />
                  <InputFormik
                    label="Data de inicio das parcelas de R$ 50,00"
                    name="paymentDate"
                    type="date"
                    required={true}
                  />
                </div>
              </section>
            )}

          <section className="flex flex-col">

          </section>
        </div>

        <div className="mt-4 flex justify-end gap-3">
          <ButtonWithLoader
            isLoading={isSubmitting}
            disabled={!formik.isValid}
            onClick={formik.handleSubmit}>Conveter</ButtonWithLoader>
        </div>
      </FormikProvider>

    </form>
  )
}